import React from 'react';
import { Tooltip as MuiTooltip } from '@mui/material';

const CopyableTooltip = React.forwardRef(({
  title,
  children,
  copyable: _copyable,
  copyText: _copyText,
  ...props
}, ref) => {
  if (title == null || title === '') {
    return children;
  }

  return (
    <MuiTooltip title={title} ref={ref} {...props}>
      {children}
    </MuiTooltip>
  );
});

CopyableTooltip.displayName = 'CopyableTooltip';

export default CopyableTooltip;
